export default "__VITE_ASSET__fG9acM2v__"